/**
 * menuData — the project's navigation reference.
 *
 * Generated by create-frontend-layout-components from the `menuData` variable
 * declared in the raw layout shells (RawHTMLDesign/layouts/*.html). All five
 * shells declare an identical tree, so there is one reference file for the whole
 * app and every layout's nav is driven from it.
 *
 * The `pages` registry is the id ↔ slug ↔ name lookup: each entry records the
 * design's numeric **page id**, the scope **page id** (the GUID in
 * RawHTMLDesign/PageDesignMap.json), the **slug**, and the **page name**.
 *
 * Routing is by **slug**, never by page id. `routeForSlug()` is the only thing
 * the layouts call, and it returns the 404 placeholder for any page whose
 * component has not been generated yet — so the nav never dead-ends.
 *
 * ── Contract for ui-components-from-reference ─────────────────────────────────
 * When a page's real component + route are built, add its slug to
 * `BUILT_PAGE_SLUGS` below. That single edit re-points its menu entry (and every
 * cross-page link) from `/404` to the real `/<slug>` route. Pages outside the
 * menu (e.g. `sign-in`) are registered here too; add new ones as they are built.
 */

/** Route of the generic 404 page — the fallback target for unbuilt pages. */
export const NOT_FOUND_ROUTE = '/404';

/** Canonical login route (also the target ProtectedRoute redirects to). */
export const LOGIN_ROUTE = '/login';

/**
 * Every page this app's navigation knows about.
 *
 * pageId   — the design's numeric PageId (null when the page is not in the menu)
 * scopeId  — the scope page id (GUID) from RawHTMLDesign/PageDesignMap.json
 * slug     — the URL segment the page's route is keyed on
 * name     — the page name as it appears in scope / the menu
 * layout   — the raw layout shell (and generated layout component) it uses
 */
export const pages = [
  {
    pageId: 73194,
    scopeId: 'b7703015-0213-428a-9af1-75cf1c80dbaf',
    slug: 'app-gallery',
    name: 'App Gallery',
    componentName: 'Home / App Gallery Screen',
    moduleId: 22427,
    module: 'identity-access-workspaces',
    designFile: 'RawHTMLDesign/identity-access-workspaces/home-app-gallery-screen/index.html',
    layout: '_default-web-layout',
    isDefaultPage: true,
  },
  {
    pageId: 73209,
    scopeId: '767e5613-a492-4af3-9c4d-c5c8919ef733',
    slug: 'users-roles',
    name: 'Users & Roles',
    componentName: 'Users, Groups & Roles',
    moduleId: 22427,
    module: 'identity-access-workspaces',
    designFile: 'RawHTMLDesign/identity-access-workspaces/users-groups-roles/index.html',
    layout: '_users-groups-roles-layout',
    isDefaultPage: false,
  },
  {
    pageId: 73221,
    scopeId: '57b2b092-e019-4ba1-a4bb-ed4478d57163',
    slug: 'workspaces-quotas',
    name: 'Workspaces & Quotas',
    componentName: 'Workspaces & Quotas',
    moduleId: 22448,
    module: 'observability-quota-cost',
    designFile: 'RawHTMLDesign/observability-quota-cost/workspaces-quotas/index.html',
    layout: '_default-web-layout-2otx06',
    isDefaultPage: false,
  },
  {
    pageId: 73222,
    scopeId: '387bce26-a5aa-4fe0-ba69-d47641906112',
    slug: 'api-credentials',
    name: 'API Credentials',
    componentName: 'Credential & Secrets Management',
    moduleId: 22451,
    module: 'administration-console',
    designFile: 'RawHTMLDesign/administration-console/credential-secrets-management/index.html',
    layout: '_default-web-layout-2otx06',
    isDefaultPage: false,
  },
  {
    pageId: 73213,
    scopeId: '4e92c9fa-ba89-41e6-8f54-afcb62d1f21d',
    slug: 'routing-policies',
    name: 'Routing Policies',
    componentName: 'Routing Policy Editor & Dry-Run',
    moduleId: 22429,
    module: 'routing-policy-engine',
    designFile: 'RawHTMLDesign/routing-policy-engine/routing-policy-editor-dry-run/index.html',
    layout: '_default-web-layout-2otx06',
    isDefaultPage: false,
  },
  {
    pageId: 73212,
    scopeId: 'f80b5193-abd0-42f8-b8e6-735f33d8b82d',
    slug: 'model-registry',
    name: 'Model Registry',
    componentName: 'Model Registry List & Model Detail',
    moduleId: 22430,
    module: 'model-registry-connector-framework',
    designFile:
      'RawHTMLDesign/model-registry-connector-framework/model-registry-list-model-detail/index.html',
    layout: '_default-web-layout',
    isDefaultPage: false,
  },
  {
    pageId: 73202,
    scopeId: 'a6998cbb-3b72-44a7-b8c6-1f904dc59a70',
    slug: 'api-job-status',
    name: 'API Job Status',
    componentName: 'Job Status / Queue Tray',
    moduleId: 22431,
    module: 'workflow-engine-runtime-adapter',
    designFile: 'RawHTMLDesign/workflow-engine-runtime-adapter/job-status-queue-tray/index.html',
    layout: '_default-web-layout-2otx06',
    isDefaultPage: false,
  },
  {
    pageId: 73203,
    scopeId: '993ac5eb-649f-44f8-9047-57f259a43b32',
    slug: 'workflow-editor',
    name: 'Workflow Editor',
    componentName: 'Workflow List & Workflow Editor',
    moduleId: 22431,
    module: 'workflow-engine-runtime-adapter',
    designFile:
      'RawHTMLDesign/workflow-engine-runtime-adapter/workflow-list-workflow-editor/index.html',
    layout: '_default-web-layout',
    isDefaultPage: false,
  },
  {
    pageId: 73193,
    scopeId: 'a4789f24-ade0-45d5-900a-cbfd234cadc4',
    slug: 'brand-elements-presets',
    name: 'Brand Elements & Presets',
    componentName: 'Creative Element Library & Element Detail Screen',
    moduleId: 22432,
    module: 'brand-preset-creative-element-manager',
    designFile:
      'RawHTMLDesign/brand-preset-creative-element-manager/creative-element-library-element-detail-screen/index.html',
    layout: '_default-web-layout-1mnzqsb',
    isDefaultPage: false,
  },
  {
    pageId: 73191,
    scopeId: '06df0715-688c-430f-8378-565684c042d4',
    slug: 'generation-studio',
    name: 'Generation Studio',
    componentName: 'Creative Studio — Generation Console',
    moduleId: 22435,
    module: 'generation-studio-prompt-interface',
    designFile:
      'RawHTMLDesign/generation-studio-prompt-interface/creative-studio-generation-console/index.html',
    layout: '_default-web-layout',
    isDefaultPage: false,
  },
  {
    pageId: 73198,
    scopeId: 'f54b083a-af47-4ab2-8703-19a456ea7c12',
    slug: 'results-variants',
    name: 'Results & Variants',
    componentName: 'Results Grid & Variant Tray',
    moduleId: 22436,
    module: 'results-variant-comparison-engine',
    designFile:
      'RawHTMLDesign/results-variant-comparison-engine/results-grid-variant-tray/index.html',
    layout: '_users-groups-roles-layout',
    isDefaultPage: false,
  },
  {
    pageId: 73192,
    scopeId: '32c5df08-6d4b-4546-acd0-b70721eeb506',
    slug: 'asset-vault-projects',
    name: 'Asset Vault & Projects',
    componentName: 'Project List & Project Detail Screen',
    moduleId: 22437,
    module: 'asset-versioning-lineage-vault',
    designFile:
      'RawHTMLDesign/asset-versioning-lineage-vault/project-list-project-detail-screen/index.html',
    layout: '_default-web-layout-1mnzqsb',
    isDefaultPage: false,
  },
  {
    pageId: 73200,
    scopeId: 'cddcde15-5a10-48e4-94d2-3d00db90f32b',
    slug: 'review-queue',
    name: 'Review Queue',
    componentName: 'Review & Approval Queue',
    moduleId: 22433,
    module: 'review-approval-feedback-engine',
    designFile: 'RawHTMLDesign/review-approval-feedback-engine/review-approval-queue/index.html',
    layout: '_default-web-layout',
    isDefaultPage: false,
  },
  {
    pageId: 73219,
    scopeId: 'af9ea1b9-dcd0-4b29-a035-5e5e5d7e4508',
    slug: 'compliance-audit',
    name: 'Compliance & Audit',
    componentName: 'Audit Search & Export',
    moduleId: 22447,
    module: 'governance-audit-provenance',
    designFile: 'RawHTMLDesign/governance-audit-provenance/audit-search-export/index.html',
    layout: '_default-web-layout-2otx06',
    isDefaultPage: false,
  },
  // Not part of the menu tree, but the anonymous entry point every layout's
  // login affordance targets — so it is registered here like any other page.
  {
    pageId: null,
    scopeId: '1cfc8a3e-ceea-4439-aa7b-38807ceed3c4',
    slug: 'sign-in',
    name: 'Sign-in / SSO Redirect Screen',
    componentName: 'Sign-in / SSO Redirect Screen',
    moduleId: 22427,
    module: 'identity-access-workspaces',
    designFile: 'RawHTMLDesign/identity-access-workspaces/sign-in-sso-redirect-screen/index.html',
    layout: 'auth-web-layout',
    isDefaultPage: false,
  },
  // Reached only via workflow (Model Registry's "Add Model Endpoint"), not the
  // main nav — registered here like `sign-in` so routeForSlug/routeForPageId
  // resolve it once built.
  {
    pageId: 73210,
    scopeId: '6eb83f84-ad55-4093-9d65-b28825dab4a1',
    slug: 'model-registration-wizard',
    name: 'Model Registration Wizard',
    componentName: 'Model Registration Wizard',
    moduleId: 22451,
    module: 'administration-console',
    designFile: 'RawHTMLDesign/administration-console/model-registration-wizard/index.html',
    layout: '_users-groups-roles-layout',
    isDefaultPage: false,
  },
  // Reached only via workflow (Model Registration Wizard's "Inspect Worker
  // Health"), not the main nav. Gated to Model Administrator + Platform
  // Administrator in App.jsx — see concern e1eb2130-3348-4f69-b488-570e03de8119
  // (the page's own scope record says Platform-Administrator-only, but the
  // workflow + TC-39225-01 require the Model Administrator to reach it too).
  {
    pageId: null,
    scopeId: '24cc0f77-b1c8-46bd-9371-6d702dbbdaa9',
    slug: 'worker-runtime-health',
    name: 'Worker & Runtime Health',
    componentName: 'Worker & Runtime Health',
    moduleId: 22451,
    module: 'administration-console',
    designFile: 'RawHTMLDesign/administration-console/worker-runtime-health/index.html',
    layout: '_default-web-layout-2otx06',
    isDefaultPage: false,
  },
  // Reached only via workflow (Model Registry's "Edit Capability Schema" /
  // "Open Capability Schema Editor" — frontend/src/pages/model-registry/
  // links.js's DESIGN_PAGE_ID.capabilitySchemaEditor already targets this
  // exact pageId), not the main nav.
  {
    pageId: 73214,
    scopeId: 'a0e8e358-a1ca-4fc5-b2cf-afe7d80f8fba',
    slug: 'capability-descriptor-editor',
    name: 'Capability Descriptor Editor',
    componentName: 'Capability Descriptor Editor',
    moduleId: 22452,
    module: 'capability-parameter-preset-service',
    designFile:
      'RawHTMLDesign/capability-parameter-preset-service/capability-descriptor-editor/index.html',
    layout: '_users-groups-roles-layout',
    isDefaultPage: false,
  },
  // Reached only via workflow (Capability Descriptor Editor's "Preview
  // Dynamic Controls"), not the main nav. Optional :modelId param handled by
  // the page itself.
  {
    pageId: null,
    scopeId: '95469c47-2cef-46eb-a388-1ea48c5f7b13',
    slug: 'dynamic-parameter-panel',
    name: 'Dynamic Parameter Panel',
    componentName: 'Dynamic Parameter Panel',
    moduleId: 22452,
    module: 'capability-parameter-preset-service',
    designFile:
      'RawHTMLDesign/capability-parameter-preset-service/dynamic-parameter-panel/index.html',
    layout: '_users-groups-roles-layout',
    isDefaultPage: false,
  },
  // Reached only via workflow (Results & Variants' "Select Variants for
  // Comparison" / "Launch Visual Diff"), not the main nav. No numeric design
  // page id exists for it (PageDesignMap.json has no page-id mapping for this
  // scope id), so it is registered here, like `worker-runtime-health` before
  // it, purely so `routeForSlug` has a slug to resolve. Built — see
  // BUILT_PAGE_SLUGS below and frontend/src/pages/comparison-view/.
  {
    pageId: null,
    scopeId: '27297b8b-94b2-449b-83ec-f716baa31d53',
    slug: 'comparison-view',
    name: 'Comparison View Screen',
    componentName: 'Comparison View Screen',
    moduleId: 22436,
    module: 'results-variant-comparison-engine',
    designFile: 'RawHTMLDesign/results-variant-comparison-engine/comparison-view-screen/index.html',
    layout: '_default-web-layout-1mnzqsb',
    isDefaultPage: false,
  },
  // Reached only via workflow (Generation Studio's "Open Creative Assistant
  // Panel" toolbar action), not the main nav — same pattern as
  // `dynamic-parameter-panel` / `comparison-view` above. Built to resolve
  // concern 9ac38edb-c324-4d3d-891c-0ace4d551e5e (use case 47086259-…'s
  // `has_page` edges omitted this screen even though TC-39218-01 opens it) —
  // see BUILT_PAGE_SLUGS below and frontend/src/pages/creative-assistant-panel/.
  {
    pageId: null,
    scopeId: 'dc49a37b-961c-44d3-87b5-defd130151ac',
    slug: 'creative-assistant-panel',
    name: 'Creative Assistant Panel',
    componentName: 'Creative Assistant Panel',
    moduleId: null,
    module: 'creative-assistant-copilot-engine',
    designFile:
      'RawHTMLDesign/creative-assistant-copilot-engine/creative-assistant-panel/index.html',
    layout: '_users-groups-roles-layout',
    isDefaultPage: false,
  },
  // Reached only via workflow (Asset Vault & Projects' "Inspect Asset
  // Lineage" — use case 6073ba2f, workflow step 2), not the main nav, same
  // pattern as `dynamic-parameter-panel` / `comparison-view` above. Built —
  // see BUILT_PAGE_SLUGS below and frontend/src/pages/asset-detail-lineage/.
  {
    pageId: null,
    scopeId: '0bf36ad1-9661-40f8-8633-d965c93eb725',
    slug: 'asset-detail-lineage',
    name: 'Asset Detail & Lineage View Screen',
    componentName: 'Asset Detail & Lineage View Screen',
    moduleId: 22437,
    module: 'asset-versioning-lineage-vault',
    designFile:
      'RawHTMLDesign/asset-versioning-lineage-vault/asset-detail-lineage-view-screen/index.html',
    layout: '_default-web-layout-1mnzqsb',
    isDefaultPage: false,
  },
  // Reached only via workflow (Workflow Editor's "Test Workflow" action, use
  // case 1287c5ff-…, workflow step 1), not the main nav — same pattern as
  // `dynamic-parameter-panel` / `comparison-view` above. Built — see
  // BUILT_PAGE_SLUGS below and frontend/src/pages/workflow-test-harness/.
  {
    pageId: null,
    scopeId: 'ce59f642-3283-4389-bcb5-a152ba9b30fb',
    slug: 'workflow-test-harness',
    name: 'Workflow Test Harness',
    componentName: 'Workflow Test Harness',
    moduleId: 22431,
    module: 'workflow-engine-runtime-adapter',
    designFile: 'RawHTMLDesign/workflow-engine-runtime-adapter/workflow-test-harness/index.html',
    layout: '_default-web-layout-1mnzqsb',
    isDefaultPage: false,
  },
  // Reached only via workflow (Workflow Test Harness's "Configure App
  // Binding" action, use case 1287c5ff-…, workflow step 2), not the main
  // nav. Built — see BUILT_PAGE_SLUGS below and
  // frontend/src/pages/creative-app-builder-binding-editor/.
  {
    pageId: null,
    scopeId: 'b2228f4d-0f90-4ae7-931d-c710d88998e4',
    slug: 'creative-app-builder-binding-editor',
    name: 'Creative App Builder & Binding Editor',
    componentName: 'Creative App Builder & Binding Editor',
    moduleId: 22431,
    module: 'workflow-engine-runtime-adapter',
    designFile:
      'RawHTMLDesign/workflow-engine-runtime-adapter/creative-app-builder-binding-editor/index.html',
    layout: '_default-web-layout-1mnzqsb',
    isDefaultPage: false,
  },
  // Reached only via workflow (Workspaces & Quotas' "View Usage Metrics"
  // action, use case 61f77339-…, workflow step 2), not the main nav — same
  // pattern as `comparison-view` / `asset-detail-lineage` above. Built — see
  // BUILT_PAGE_SLUGS below and frontend/src/pages/usage-cost-dashboards/.
  {
    pageId: null,
    scopeId: '1e7b8a39-8e4a-4f7f-ae54-ba35a28bd4f7',
    slug: 'usage-cost-dashboards',
    name: 'Usage & Cost Dashboards',
    componentName: 'Usage & Cost Dashboards',
    moduleId: 22448,
    module: 'observability-quota-cost',
    designFile: 'RawHTMLDesign/observability-quota-cost/usage-cost-dashboards/index.html',
    layout: '_default-web-layout-1mnzqsb',
    isDefaultPage: false,
  },
];

/**
 * Slugs whose page component + route actually exist.
 *
 * Every menu entry whose slug is absent here resolves to the 404 placeholder
 * (see `routeForSlug`), so the nav never dead-ends. A slug is appended once the
 * page's component AND its route in App.jsx both exist.
 */
export const BUILT_PAGE_SLUGS = [
  'sign-in',
  'app-gallery',
  'reel-generator',
  'episodes',
  'voiceover-studio',
  'talking-avatar',
  'media-library',
  // The Characters page (formerly Presenters & Looks). The old lora-training
  // route still exists as a redirect, but the menu links to /characters.
  'characters',
  'orchestration-command-center',
  'users-roles',
  'model-registry',
  'model-registration-wizard',
  'worker-runtime-health',
  'capability-descriptor-editor',
  'dynamic-parameter-panel',
  'results-variants',
  'generation-studio',
  'comparison-view',
  'asset-detail-lineage',
  'asset-vault-projects',
  'workflow-editor',
  'workflow-test-harness',
  'creative-app-builder-binding-editor',
  'api-credentials',
  'api-job-status',
  'routing-policies',
  'workspaces-quotas',
  'usage-cost-dashboards',
  'compliance-audit',
  'brand-elements-presets',
  'brand-rules',
  'consent-register',
  'review-queue',
  'creative-assistant-panel',
  'scene-bibles',
  'art-styles',
  'show-packages',
  'work-surface',
  // My Approvals (inbox + request detail) and Settings → Approval policies —
  // Episodes Plan 2 Task 12.
  'approvals',
  'approval-policies',
];

/**
 * The navigation tree, mirroring the design's `menuData` exactly — same labels,
 * same icons, same grouping, same order. Group nodes (no page of their own)
 * carry `slug: null`.
 */
export const menu = {
  children: [
    // My Work — the active work surface (Addendum A DMI-23). First in the
    // nav because it is the default home (DMI-23.01): only what carries an
    // open obligation on the signed-in user, with App Gallery kept reachable
    // as a named destination right below (DMI-23.07). Not in the raw
    // design's menuData — added with pageId: null like reel-generator.
    {
      label: 'My Work',
      icon: 'fa fa-inbox',
      slug: 'work-surface',
      pageId: null,
      moduleId: null,
      showInBottomBar: false,
      children: null,
    },
    // My Approvals — the configurable-chain approvals inbox (Episodes Plan 2
    // Task 12). Every user: whether anything is actually waiting on them is
    // decided server-side (GET /api/approvals/inbox), same as My Work above.
    {
      label: 'My Approvals',
      icon: 'fa fa-check-double',
      slug: 'approvals',
      pageId: null,
      moduleId: null,
      showInBottomBar: false,
      children: null,
    },
    // ---- Creative-first: the surfaces a creative user works in, in flow order.
    {
      label: 'App Gallery',
      icon: 'fa fa-th-large',
      slug: 'app-gallery',
      pageId: 73194,
      moduleId: 22427,
      showInBottomBar: false,
      children: null,
    },
    // Reel Generator leads: it is the product — a whole narrated reel from a
    // brief through six reviewed gates. Everything after it is either a
    // single-asset tool the reel also uses, or a place work ends up.
    {
      label: 'Reel Generator',
      icon: 'fa fa-clapperboard',
      slug: 'reel-generator',
      pageId: null,
      moduleId: null,
      showInBottomBar: false,
      children: null,
    },
    // Episodes — the producer's running order: import a rundown, approve the
    // breakdown, produce segment reels. Not in the raw design's menuData —
    // added with pageId: null like reel-generator, right after it.
    {
      label: 'Episodes',
      icon: 'fa fa-list-ol',
      slug: 'episodes',
      pageId: null,
      moduleId: null,
      showInBottomBar: false,
      children: null,
    },
    // Named for what it MAKES, not for what it is. "Generation Studio" told a
    // producer nothing about whether it produced stills, clips or audio.
    {
      label: 'Image & Video Gen',
      icon: 'fa fa-magic',
      slug: 'generation-studio',
      pageId: 73191,
      moduleId: 22435,
      showInBottomBar: false,
      children: null,
    },
    {
      label: 'Voiceover Studio',
      icon: 'fa fa-microphone-lines',
      slug: 'voiceover-studio',
      pageId: null,
      moduleId: null,
      showInBottomBar: false,
      children: null,
    },
    {
      // PROVEN, not shipped: MuseTalk lip-sync runs on the L4 but cannot be
      // resident alongside Wan on one 24GB card. The page works and shows the
      // rendered reads; generating a new one is what is blocked, and the page
      // says so where the action lives. `constrained` renders the Preview tag.
      label: 'Talking Avatar',
      icon: 'fa fa-user-tie',
      slug: 'talking-avatar',
      constrained: true,
      pageId: null,
      moduleId: null,
      showInBottomBar: false,
      children: null,
    },
    // Library: the three places work ENDS UP, folded into one group. As three
    // top-level siblings ("Media Library", "Results & Variants", "Asset Vault
    // & Projects") they were three names for "my stuff" with no visible
    // difference between them. A group node has no slug of its own (a node
    // with both slug and children renders as a toggle that never navigates).
    // One entry. The three views (Media, Generations, Projects) are tabs in a
    // shared header on the pages themselves (components/LibraryTabs), which is
    // where "which of these do I want" is actually decided — beside the
    // content, not in a sidebar submenu of three near-synonyms.
    {
      label: 'Library',
      icon: 'fa fa-photo-film',
      slug: 'media-library',
      alsoActive: ['/results-variants', '/asset-vault-projects'],
      pageId: null,
      moduleId: null,
      showInBottomBar: false,
      children: null,
    },
    {
      // Renamed from "Creative Studio", which competed with the product name
      // and with the surfaces that actually create things. This group governs
      // how work is made — brand kit, looks, and the rules — so it is named for
      // that. Results & Variants moved to the job that produced it and Asset
      // Vault merged into Media Library: both were places things END UP, which
      // is what made this group read as a drawer.
      label: 'Brand & Identity',
      icon: 'fa fa-swatchbook',
      slug: null,
      pageId: null,
      moduleId: null,
      showInBottomBar: null,
      children: [
        {
          label: 'Brand Kit',
          icon: 'fa fa-palette',
          slug: 'brand-elements-presets',
          pageId: 73193,
          moduleId: 22432,
          showInBottomBar: false,
          children: null,
        },
        {
          // Scene Bibles (Addendum A DMI-21) — the set, cast and staging a
          // reel holds constant, versioned and lockable. Lives beside Brand
          // Kit and Characters because, like them, it governs HOW
          // work is made (this is the group formerly named Creative Studio).
          // Not in the raw design's menuData — added with pageId: null like
          // reel-generator above.
          label: 'Scene Bibles',
          icon: 'fa fa-book-open',
          slug: 'scene-bibles',
          pageId: null,
          moduleId: null,
          showInBottomBar: false,
          children: null,
        },
        {
          // Animation Styles — the locked looks a world is drawn in; picked on
          // a draft Scene Bible. pageId: null like scene-bibles above.
          label: 'Animation Styles',
          icon: 'fas fa-film',
          slug: 'art-styles',
          pageId: null,
          moduleId: null,
          showInBottomBar: false,
          children: null,
        },
        {
          // Show Packages — the standing open/close + stings a programme
          // reuses byte-identical every episode. Beside Scene Bibles because
          // it is the same KIND of object: a locked continuity definition
          // the Reel Generator pins, governing HOW work is made. Added with
          // pageId: null like scene-bibles above.
          label: 'Show Packages',
          icon: 'fa fa-tv',
          slug: 'show-packages',
          pageId: null,
          moduleId: null,
          showInBottomBar: false,
          children: null,
        },
        {
          // Renamed from "Presenters & Looks": the page is now the model-sheet
          // home for a character (portrait, identity engine, wardrobe, kit,
          // voice, intro clip) with training folded in.
          label: 'Characters',
          icon: 'fa fa-user-tie',
          slug: 'characters',
          pageId: null,
          moduleId: null,
          showInBottomBar: false,
          children: null,
        },
        {
          // The authorised-identity register. It sits beside Characters
          // deliberately: a Look of a real person cannot be trained or
          // used without a live consent record here, so the two are read
          // together. Kept out of Users & Roles, which is about people who
          // hold logins — a person in this register may have no account at all.
          label: 'Consent Register',
          icon: 'fa fa-file-signature',
          slug: 'consent-register',
          pageId: null,
          moduleId: null,
          showInBottomBar: false,
          children: null,
        },
        {
          label: 'Brand Rules',
          icon: 'fa fa-shield-halved',
          slug: 'brand-rules',
          pageId: null,
          moduleId: null,
          showInBottomBar: false,
          children: null,
        },
      ],
    },
    // ---- Production & operations: the orchestration engine and the pipelines.
    // Orchestration Command Center — the TECHNICAL ORCHESTRATION: live job
    // queue, GPU worker fleet, routing traces, SSE. Distinct from the Reel
    // Generator's creative-production orchestration above.
    {
      // "Command Center" is the name the requirements and every workstream
      // plan use, and the slug has always been orchestration-command-center —
      // only the nav label was shortened to "Orchestration", which read as a
      // vague concept rather than the operations console it is.
      label: 'Command Center',
      icon: 'fa fa-satellite-dish',
      slug: 'orchestration-command-center',
      pageId: null,
      moduleId: null,
      showInBottomBar: false,
      children: null,
    },
    {
      label: 'Workflows',
      icon: 'fa fa-project-diagram',
      slug: null,
      pageId: null,
      moduleId: null,
      showInBottomBar: null,
      children: [
        {
          label: 'API Job Status',
          icon: 'fa fa-tasks',
          slug: 'api-job-status',
          pageId: 73202,
          moduleId: 22431,
          showInBottomBar: false,
          children: null,
        },
        {
          label: 'Workflow Editor',
          icon: 'fa fa-sitemap',
          slug: 'workflow-editor',
          pageId: 73203,
          moduleId: 22431,
          showInBottomBar: false,
          children: null,
        },
      ],
    },
    {
      label: 'Review & Quality',
      icon: 'fa fa-check-double',
      slug: null,
      pageId: null,
      moduleId: null,
      showInBottomBar: null,
      children: [
        {
          label: 'Review Queue',
          icon: 'fa fa-clipboard-check',
          slug: 'review-queue',
          pageId: 73200,
          moduleId: 22433,
          showInBottomBar: false,
          children: null,
          // Senior Creative / Approver + Platform Administrator only — matches
          // this page's RoleRoute gate in App.jsx (TC-39230-02's nav-hiding
          // pattern, reused here for the same reason as Compliance & Audit
          // immediately below).
          requiredRoles: ['approver', 'platform_administrator'],
        },
        {
          label: 'Compliance & Audit',
          icon: 'fa fa-shield-alt',
          slug: 'compliance-audit',
          pageId: 73219,
          moduleId: 22447,
          showInBottomBar: false,
          children: null,
          // Auditor/Compliance + Platform Administrator only (matches this
          // page's RoleRoute gate in App.jsx) — TC-39230-02 requires the nav
          // entry to be hidden for every other role, not merely relying on
          // the route redirect.
          requiredRoles: ['auditor', 'platform_administrator'],
        },
      ],
    },
    // ---- Administration LAST and role-gated: hidden entirely for creative
    // users (they never see these), a "separate login" in effect. Model
    // administration and platform administration live here, out of the
    // creative flow.
    {
      label: 'Models & Routing',
      icon: 'fa fa-network-wired',
      slug: null,
      pageId: null,
      moduleId: null,
      showInBottomBar: null,
      // Whole group hidden unless the user is a Model or Platform Administrator.
      requiredRoles: ['model_administrator', 'platform_administrator'],
      children: [
        {
          label: 'Routing Policies',
          icon: 'fa fa-route',
          slug: 'routing-policies',
          pageId: 73213,
          moduleId: 22429,
          showInBottomBar: false,
          children: null,
        },
        {
          label: 'Model Registry',
          icon: 'fa fa-cubes',
          slug: 'model-registry',
          pageId: 73212,
          moduleId: 22430,
          showInBottomBar: false,
          children: null,
        },
      ],
    },
    // Approval policies (Episodes Plan 2 Task 12). Sits next to Administration
    // in the rail, but is deliberately its OWN top-level node rather than a
    // child of the Administration group below: Administration carries
    // `requiredRoles: ['platform_administrator']` at the GROUP level, and
    // filterMenuForRoles() (config/menuData.js) drops a group — and every
    // child under it — the moment the group node itself fails the role check,
    // never reaching the child's own `requiredRoles`. A workspace Owner who
    // is not a platform administrator must still be able to reach this page
    // (task-12 ruling), and menu filtering has no way to express "Owner", so
    // this entry carries no `requiredRoles` at all and is visible to every
    // signed-in user. The backend's own 403 (platform admin or workspace
    // Owner only, approval.service.js savePolicyVersion) is what actually
    // gates it, shown in-page by PolicyEditor.
    {
      label: 'Approval Policies',
      icon: 'fa fa-sitemap',
      slug: 'approval-policies',
      pageId: null,
      moduleId: null,
      showInBottomBar: false,
      children: null,
    },
    {
      label: 'Administration',
      icon: 'fa fa-cogs',
      slug: null,
      pageId: null,
      moduleId: null,
      showInBottomBar: null,
      // Whole group hidden unless the user is a Platform Administrator.
      requiredRoles: ['platform_administrator'],
      children: [
        {
          label: 'Users & Roles',
          icon: 'fa fa-users-cog',
          slug: 'users-roles',
          pageId: 73209,
          moduleId: 22427,
          showInBottomBar: false,
          children: null,
        },
        {
          label: 'Workspaces & Quotas',
          icon: 'fa fa-chart-pie',
          slug: 'workspaces-quotas',
          pageId: 73221,
          moduleId: 22448,
          showInBottomBar: false,
          children: null,
        },
        {
          label: 'API Credentials',
          icon: 'fa fa-key',
          slug: 'api-credentials',
          pageId: 73222,
          moduleId: 22451,
          showInBottomBar: false,
          children: null,
        },
      ],
    },
  ],
  /** The design's `DefaultMenuItem` — the app's landing page. */
  defaultMenuItem: {
    label: 'App Gallery',
    icon: 'fa fa-th-large',
    slug: 'app-gallery',
    pageId: 73194,
    moduleId: 22427,
    showInBottomBar: false,
    children: null,
  },
};

// ---- Lookups ---------------------------------------------------------------

/** The page registry entry for a slug, or undefined. */
export function pageBySlug(slug) {
  return pages.find((page) => page.slug === slug);
}

/** The page registry entry for the design's numeric page id, or undefined. */
export function pageByPageId(pageId) {
  return pages.find((page) => page.pageId === pageId);
}

/** True when the page's component + route have been generated. */
export function isPageBuilt(slug) {
  return !!slug && BUILT_PAGE_SLUGS.includes(slug);
}

/**
 * The route a slug should link to.
 *
 * Built pages resolve to `/<slug>`; anything not built yet resolves to the 404
 * placeholder so no link points nowhere (the layout dims those entries).
 */
export function routeForSlug(slug) {
  if (!slug) return NOT_FOUND_ROUTE;
  return isPageBuilt(slug) ? `/${slug}` : NOT_FOUND_ROUTE;
}

/** Route for a design page id — resolved through the slug, never by id. */
/**
 * Design page ids that have no registry entry of their own but whose target
 * page IS built under a different slug. Cross-page links in the raw design
 * markup reference these ids; without an alias they resolve to `/404` even
 * though the destination exists. Aliasing them here fixes every such link (and
 * any backend-driven `targetPageId`) in one place.
 */
const PAGE_ID_SLUG_ALIASES = {
  73190: 'comparison-view', // "Side-by-Side Comparison View" / "Variant Comparison Engine"
  73197: 'asset-vault-projects', // "Asset Vault"
  73196: 'asset-vault-projects', // "View All History" — no dedicated history page; use the vault
  73211: 'worker-runtime-health', // "Worker Health" (destination is built, just unregistered)
};

export function routeForPageId(pageId) {
  const slug = pageByPageId(pageId)?.slug ?? PAGE_ID_SLUG_ALIASES[pageId];
  return routeForSlug(slug);
}

/** Landing route: the design's DefaultMenuItem, resolved by slug. */
export function defaultRoute() {
  return routeForSlug(menu.defaultMenuItem.slug);
}

/** Route of the sign-in page — where the layouts' login affordance points. */
export function signInRoute() {
  return routeForSlug('sign-in');
}

/** Flat list of every leaf (page-bearing) menu entry, in menu order. */
export function menuLeaves(nodes = menu.children) {
  return nodes.flatMap((node) =>
    node.children && node.children.length ? menuLeaves(node.children) : [node]
  );
}

/**
 * True when `item` should render for a user holding `roleKeys`.
 *
 * A node with no `requiredRoles` is unrestricted (today's default for every
 * existing entry). A node that declares `requiredRoles` is hidden unless the
 * caller holds at least one of them — e.g. Compliance & Audit above, whose
 * `requiredRoles` mirrors its `RoleRoute` gate in App.jsx.
 */
export function isMenuItemVisibleForRoles(item, roleKeys = []) {
  if (!item.requiredRoles || item.requiredRoles.length === 0) return true;
  return item.requiredRoles.some((role) => roleKeys.includes(role));
}

/**
 * Filters a menu tree down to the nodes visible for `roleKeys`, recursively.
 * A group with every child filtered out is itself dropped rather than
 * rendered empty.
 */
export function filterMenuForRoles(nodes = menu.children, roleKeys = []) {
  return nodes.reduce((visible, node) => {
    if (!isMenuItemVisibleForRoles(node, roleKeys)) return visible;
    if (node.children && node.children.length) {
      const children = filterMenuForRoles(node.children, roleKeys);
      if (children.length === 0) return visible;
      return [...visible, { ...node, children }];
    }
    return [...visible, node];
  }, []);
}

export default menu;
